<template>
    <md-content class="survey-group-container md-scrollbar"
                >
        <span v-if="field.name">{{field.name}}</span>
        <div class="survey-group-container__field"
             v-for="(child, index) in field.children"
             v-bind:key="index" v-bind:field="child">
            <survey-field v-bind:field="child" @nodeChange="onNodeChange"
                          v-bind:key="child.id"></survey-field>
        </div>
    </md-content>
</template>

<script>
import store from '../../store';

export default {
  name: 'SurveyGroup',
  props: ['field'],
  data: () => ({
    readonlyMode: store.state.visit.readonlyMode,
  }),
  methods: {
    onNodeChange() {
      this.$emit('nodeChange', this.field);
    },
  },
};
</script>

<style src="./SurveyGroup.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/SurveyGroup/SurveyGroup.vue